import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLanguage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#A5A5AA"
      d="M9.453 15.15h5.076l1.026 2.7h1.881l-4.599-11.7h-1.674l-4.599 11.7h1.881l1.008-2.7ZM12 8.382l1.863 4.968h-3.726L12 8.382ZM19.2 3H4.8C3.81 3 3 3.81 3 4.8v14.4c0 .99.81 1.8 1.8 1.8h14.4c.99 0 1.8-.81 1.8-1.8V4.8c0-.99-.81-1.8-1.8-1.8Zm0 16.2H4.8V4.8h14.4v14.4Z"
    />
  </svg>
);
export default SvgLanguage;
